export default __webpack_public_path__ + "locales/ru/DownloadDialog.json?hash=0d6b23e39a76b7abe5d2b1584f963cd5";